package app.bloomey.web.modules.analytics

import app.bloomey.web.core.data.models.ApiResponse
import app.bloomey.web.core.data.models.TimeSeriesQuery
import app.bloomey.web.core.data.models.TimesSeriesData
import app.bloomey.web.utils.bodySuccess
import io.ktor.client.*
import io.ktor.client.request.*
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class AnalyticsApi : KoinComponent {
    private val client: HttpClient by inject()

    suspend fun totalUsers(query: TimeSeriesQuery): ApiResponse<List<TimesSeriesData<Long>>> {
        return client.post("analytics/v1/totalUsers"){
            setBody(query)
        }
            .bodySuccess()
    }

    suspend fun activeUsers(query: TimeSeriesQuery): ApiResponse<List<TimesSeriesData<Long>>> {
        return client.post("analytics/v1/activeUsers") {
            setBody(query)
        }.bodySuccess()
    }

    suspend fun newUsers(query: TimeSeriesQuery): ApiResponse<List<TimesSeriesData<Long>>> {
        return client.post("analytics/v1/newUsers") {
            setBody(query)
        }.bodySuccess()
    }
}